import $ from 'jquery'

import base from '../../store/base'
import moment from 'moment'
import { getUserData } from '../../lib/token'

const path = base
window.$ = window.jQuery = require('jquery')
require('select2')
require('select2/dist/js/i18n/pt-BR')

export function init(id, options, change) {
  const element = $(id)
  const map = item => {
    const id = item.Id || item[options.propertyId]
    const text = item.Nome || item[options.propertyNome]
    return { id, text }
  }
  const defaultFn = {
    data(params) {
      return {
        nome: params.term,
        page: params.page
      }
    },
    processResults(data, params) {
      params.page = params.page || 1
      const results = data.Result.map(options.map || map)

      return {
        results,
        pagination: {
          more: params.page * 10 < data.TotalCount
        }
      }
    }
  }

  let search
  if (options.search === false) {
    search = -1
  }

  const config = {
    language: 'pt-BR',
    minimumResultsForSearch: search,
    multiple: options.multiple,
    placeholder: options.placeholder,
    allowClear: true,
    ajax: {
      url: path + options.url,
      dataType: 'json',
      delay: 250,
      data: options.data || defaultFn.data,
      processResults: options.processResults || defaultFn.processResults,
      cache: true,
      transport: (params, success, failure) => {
        const userData = getUserData()
        if (userData && userData.access_token) {
          const { refresh_token, access_token } = userData

          params.beforeSend = request => {
            request.setRequestHeader('Authorization', `bearer ${access_token}`)
          }

          let $request
          if (moment().isBefore(new Date(userData['.expires']))) {
            $request = $.ajax(params)
            $request.fail(failure)
          } else {
            $request = window.vue.$store._actions['login/refreshToken']
              [0]({ refresh_token })
              .then(() => {
                return $.ajax(params)
              })
              .catch(failure)
          }

          $request.then(success)
          return $request
        } else {
          const $request = $.ajax(params)
          $request.fail(failure)
          $request.then(success)
          return $request
        }
      }
    },
    escapeMarkup: markup => markup,
    minimumInputLength: options.minimumInputLength || 0,
    templateResult: options.templateResult || (result => result.text),
    templateSelection: options.templateSelection || (result => result.text)
  }

  element
    .select2(config)
    .on('change', () => {
      if (options.multiple) {
        const selected = element.select2('data')
        $('.select2-selection__rendered').removeAttr('title')

        if (!selected) {
          change([])
        } else {
          change(selected)
        }
      } else {
        const selected = element.select2('data')[0]
        $('.select2-selection__rendered').removeAttr('title')

        if (!selected) {
          change({ id: '', text: '' })
        } else {
          change(selected)
        }
      }
    })
    .data('select2')
    .listeners['*'].push(function(name) {
      if (name === 'select') {
        $(this.$element)
          .next('.select2')
          .find('.select2-selection')
          .focus()
      }
    })

  $('.select2-selection__rendered').removeAttr('title')
}

export function destroy(id) {
  $(id)
    .off()
    .select2('destroy')
}

export function trigger(id, options, change, value, text) {
  $(id)
    .empty()
    .append(
      $('<option/>')
        .val(value)
        .text(text)
    )
  init(id, options, change)
}

export function clear(id) {
  $(id).empty()
}
